export const transition = {
  property: {
    common: 'background-color, color, fill, stroke, opacity, transform',
  },
};
